type Mode = 'development' | 'staging' | 'production-non-store' | 'production'

export const MODE: Mode = (import.meta.env.MODE as Mode) || 'development'
export const DASHBOARD_URL = import.meta.env.VITE_DASHBOARD_URL || ''
export const MISSIONS_URL = import.meta.env.VITE_MISSIONS_URL || ''
export const AUTH_PUBLIC_ORIGIN_URL =
  import.meta.env.VITE_APP_SHELL === 'missions' ? MISSIONS_URL : DASHBOARD_URL
export const API_URL = import.meta.env.VITE_API_URL || ''
export const NECTAR_API_URL = import.meta.env.VITE_NECTAR_API_URL || ''
export const EXTENSION_ID = import.meta.env.VITE_EXTENSION_ID || ''
export const GIT_BRANCH = import.meta.env.VITE_GIT_BRANCH || ''
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN || ''
export const REF_INVITE_URL = import.meta.env.VITE_REF_INVITE_URL || ''
export const GTM_KEY = import.meta.env.VITE_GTM_KEY || ''
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || ''

export const LIVEKIT_PUBLIC_URL = import.meta.env.VITE_LIVEKIT_PUBLIC_URL || ''

export const VITE_SOLANA_RPC_ENDPOINT = import.meta.env.VITE_SOLANA_RPC_ENDPOINT || ''
export const VITE_SOLANA_VALIDATOR_ADDRESS = import.meta.env.VITE_SOLANA_VALIDATOR_ADDRESS || ''
export const VITE_SOLANA_PUBLIC_NETWORK = import.meta.env.VITE_SOLANA_PUBLIC_NETWORK || 'devnet'
